import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import EmailIcon from '@mui/icons-material/Email';
import EventIcon from '@mui/icons-material/Event';
import ImageIcon from '@mui/icons-material/Image';
import SmsIcon from '@mui/icons-material/Sms';
import VideocamIcon from '@mui/icons-material/Videocam';
import VoicemailIcon from '@mui/icons-material/Voicemail';
import TimelineDot from '@mui/lab/TimelineDot';
import * as React from 'react';
import { ApActionType } from '../../../sic-lib/enums/ApActionType';

interface Props {
    actionType: ApActionType;
}

export default function ApEditorTimelineIcon({ actionType }: Props) {
    const [actionIcon, setActionIcon] = React.useState<React.ReactElement | null>(null);

    React.useEffect(() => {
        switch (actionType) {
            case ApActionType.displayEvent:
                setActionIcon(<AssignmentTurnedInIcon />);
                break;
            case ApActionType.email:
                setActionIcon(<EmailIcon />);
                break;
            case ApActionType.picture:
                setActionIcon(<ImageIcon />);
                break;
            case ApActionType.sms:
                setActionIcon(<SmsIcon />);
                break;
            case ApActionType.task:
                setActionIcon(<EventIcon />);
                break;
            case ApActionType.video:
                setActionIcon(<VideocamIcon />);
                break;
            case ApActionType.voicemail:
                setActionIcon(<VoicemailIcon />);
                break;
            default:
                setActionIcon(<AssignmentTurnedInIcon />);
        }
    }, [actionType]);

    return <TimelineDot>{actionIcon}</TimelineDot>;
}
